import { LineupSurveyList as LineupSurveyListComponent } from './LineupSurveyList.component';
import { connector } from './LineupSurveyList.connector';

export const LineupSurveyList = connector(LineupSurveyListComponent)
